import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import * as fromRoot from '@root/reducers';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { getUserToken } from '@root/helpers/tokenStorage';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import * as logoutActions from '@modules/login/actions/logout.actions';


@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  constructor(private router: Router, private rootStore: Store<fromRoot.State>,) {}
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token: string = getUserToken();

        if (token && request.url.indexOf('v2-extapi.lunextelecom.com') == -1) {
          request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + token) });
          // request = request.clone({ headers: request.headers.set('Authorization', token) });
        } else if(request.url.indexOf('v2-extapi.lunextelecom.com') > -1) {
          request = request.clone({ headers: request.headers.set('Authorization', 'Basic ' + btoa('APGITINCTESTING:apgit11022022')) });

        }

        if (!(request.body instanceof FormData) && !request.headers.has('Content-Type')) {
          request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
        }

        request = request.clone({ headers: request.headers.set('Accept', 'application/json') });
        request = request.clone({ headers: request.headers.set('Access-Control-Allow-Origin', '*') }); //KenRoy
        request = request.clone({ headers: request.headers.set('Access-Control-Allow-Headers', 'Content-Type') }); //KenRoy
        request = request.clone({ headers: request.headers.set('Access-Control-Allow-Methods', '*') }); //KenRoy


        return next.handle(request).pipe(
          map((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
            }
            return event;
          }),
          catchError((error: HttpErrorResponse) => {
            let data = {};
            data = {
              reason: error && error.error && error.error.reason ? error.error.reason : '',
              status: error.status
            };
            if ([401].indexOf(error.status) !== -1) {
              if(request.headers.has('Authorization'))
                this.logoutUser();
          }
            return throwError(error);
          }));
    }

  logoutUser() {
      localStorage.removeItem('token');
      this.rootStore.dispatch(new logoutActions.Logout);
      this.router.navigate(['/login']);
  }
}
